import React from "react";
import moment from "moment";

const ContactSubmittedItem = ({ data, index }) => {
  const createdAt = moment(new Date(data.createdAt)).format("MMM DD, YY");

  return (
    <tr className="border-b">
      <td className="px-2 py-4 overflow-clip">
        <span>{data.name}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{data.email}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{createdAt}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{data.message}</span>
      </td>
    </tr>
  );
};

export default ContactSubmittedItem;
